module.exports = __webpack_public_path__ + "static/media/tailwindcss.3566936a.svg";